import { useState, useEffect } from "react";
import { Sparkle } from "lucide-react";

const LandingMotionTexts = () => {
  const contents = [
    "Team Docs",
    "Project Roadmaps",
    "Task Tracking",
    "Knowledge Based",
    "Collaborative Notes",
    "Project Management"
  ];

  const [position, setPosition] = useState(0);
  
  const contentWidth = 1800;
  
  useEffect(() => {
    const animationSpeed = 30; 
    
    // Create animation interval
    const interval = setInterval(() => {
      setPosition(prevPosition => {
        if (prevPosition <= -contentWidth / 2) {
          return 0;
        }
        return prevPosition - 1; 
      });
    }, animationSpeed);
    
    return () => clearInterval(interval);
  }, []);
  
  return (
    <div className="bg-black py-6 w-full h-[82px] lg:h-[147px] grid items-center overflow-hidden">
      <div className="bg-white w-full h-[34px] lg:h-[44px]] rotate-[-2.5deg] flex items-center relative overflow-hidden">
        <div 
          className="flex items-center gap-4 absolute whitespace-nowrap"
          style={{ transform: `translateX(${position}px)` }}
        >
          {contents.map((content, index) => (
            <div key={index} className="flex items-center gap-4">
              <p className="text-[20px] lg:text-[30px] leading-10 text-gray-900 whitespace-nowrap">{content}</p>
              <Sparkle size={34} fill="text-gray-900" />
            </div>
          ))}
        </div>
        
        <div 
          className="flex items-center gap-4 absolute whitespace-nowrap"
          style={{ transform: `translateX(${position + contentWidth}px)` }}
        >
          {contents.map((content, index) => (
            <div key={`duplicate-${index}`} className="flex items-center gap-4">
              <p className="text-3xl leading-10 text-gray-900 whitespace-nowrap">{content}</p>
              <Sparkle size={34} fill="text-gray-900" />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default LandingMotionTexts;